import firebase from "firebase/app";
import { firebaseInstance } from "./firebaseInstance";

type Credentials = {
  email: string;
  password: string;
};

export const authenticateWithGoogle = () => {
  const provider = new firebase.auth.GoogleAuthProvider();
  return firebaseInstance.auth().signInWithPopup(provider);
};

export const authenticateWithFacebook = () => {
  const provider = new firebase.auth.FacebookAuthProvider();
  return firebaseInstance.auth().signInWithPopup(provider);
};

export const authenticateWithCredential = (credentials: Credentials) => {
  return firebaseInstance
    .auth()
    .signInWithEmailAndPassword(credentials.email, credentials.password);
};

export const onAutentication = (
  callback: (next: firebase.User | null) => any
) => {
  const auth = firebaseInstance.auth();

  auth.onAuthStateChanged(async (next: firebase.User | null) => {
    callback(next);
  });
};

export const logout = (callback: () => any, finallyCallback?: () => any) => {
  firebaseInstance.auth().signOut().then(callback).finally(finallyCallback);
};
